import { z } from "zod";

const envSchema = z.object({
  VITE_API_URL: z
    .url({ protocol: /^https?$/, error: "VITE_API_URL must be the API's http(s) address" })
    .transform((url) => url.replace(/\/$/, "")),
});

const parsed = envSchema.safeParse({ VITE_API_URL: import.meta.env.VITE_API_URL || undefined });

/**
 * Why the dashboard can't start, or null. The dashboard has no offline data, so main.tsx shows a
 * configuration screen instead of rendering screens that would only fail.
 */
export const envProblem: string | null = parsed.success
  ? null
  : (parsed.error.issues[0]?.message ?? "VITE_API_URL is not set");

/** Validated build-time settings. `apiUrl` is empty only while `envProblem` is set. */
export const env = { apiUrl: parsed.success ? parsed.data.VITE_API_URL : "" };
